<template>
  <div class="main-container" @click.stop="clickBody">
    <topBar></topBar>
    <router-view></router-view>
  </div>
</template>

<script setup>
import topBar from "@/components/topBar.vue";
import {eventBus} from "@/util/eventBus";

const clickBody = () => {
  eventBus.emit('clickBody')
}
</script>

<style lang="scss" scoped>
.main-container {
  height: 100vh;
  background: #f4f5f7;
  display: flex;
  flex-direction: column;
  .body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}
</style>